import { store } from '../store/index.js'

export default (to, from, next) => {
  if (store.getters.user) {
    next()
  } else {
    // if not signed in lets grab this url and take them to sign in
    const loginpath = window.location.pathname
    if (loginpath === '/') {
      next({ name: 'SignIn' })
    }
    next({ name: 'SignIn', query: { from: loginpath } })
  }
}
